// src/features/rrhh/mensajeria/components/ReclamosTable.jsx
import {
  Avatar,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const HEADERS = ["Empleado", "Tipo", "Prioridad", "Estado", "Fecha", "Sucursal"];

// Opcional: anchos para que header y body calcen perfecto
const COL_W = ["20%", "16%", "16%", "16%", "16%", "16%"];

function EstadoPill({ estadoApi, label }) {
  const MAP = {
    NUEVO:       { bg: "rgba(239,68,68,.80)",  fg: "rgba(127,29,29,1)" },   // rojo
    EN_REVISION: { bg: "rgba(245,158,11,.80)", fg: "rgba(120,53,15,1)" },   // amarillo
    RESPONDIDO:  { bg: "rgba(148,163,184,.80)",fg: "rgba(30,41,59,1)" },    // gris
    CERRADO:     { bg: "rgba(34,197,94,.80)",  fg: "rgba(20,83,45,1)" },    // verde
  };

  const cfg = MAP[String(estadoApi)] || { bg: "rgba(203,213,225,.35)", fg: "rgba(30,41,59,1)" };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        bgcolor: cfg.bg,
        boxShadow: "inset 0px 0px 3px rgba(96, 96, 113, 0.35)",
      }}
    >
      <Typography sx={{ fontSize: 13.5, fontWeight: 800, color: cfg.fg, lineHeight: 1 }}>
        {label}
      </Typography>
    </Box>
  );
}


export default function ReclamosTable({ rows = [], selectedId, onSelect }) {
  return (
    <Paper
      sx={{
        height: "60vh",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER (sin scroll) */}
      <TableContainer sx={{ flex: "0 0 auto" }}>
        <Table sx={{ tableLayout: "fixed" }}>
          <colgroup>
            {COL_W.map((w, i) => (
              <col key={i} style={{ width: w }} />
            ))}
          </colgroup>

          <TableHead>
            <TableRow>
              {HEADERS.map((h) => (
                <TableCell
                  key={h}
                  align="center"
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: "common.white",
                    bgcolor: (t) => t.palette?.neutral?.[600],
                  }}
                >
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>

      {/* BODY (scroll SOLO acá) */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <TableContainer sx={{ height: "100%", overflowY: "auto" }}>
          <Table sx={{ tableLayout: "fixed" }}>
            <colgroup>
              {COL_W.map((w, i) => (
                <col key={i} style={{ width: w }} />
              ))}
            </colgroup>

            <TableBody>
              {rows.map((row) => {
                const active = row.id === selectedId;
                return (
                  <TableRow
                    key={row.id}
                    onClick={() => onSelect?.(row.id)}
                    sx={{
                      cursor: "pointer",
                      bgcolor: (t) => (active ? t.palette?.neutral?.[100] : t.palette?.neutral?.[50]),
                      "&:hover": { bgcolor: (t) => t.palette?.neutral?.[100] },
                    }}
                  >
                    <TableCell sx={{ px: 1, py: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          px: 1,
                          py: 0.5,
                          bgcolor: (t) => t.palette?.neutral?.[200],
                          borderRadius: 999,
                          boxShadow: "inset 0px 0px 4px rgba(165, 165, 178, 0.9)",
                          border: active ? "2px solid rgba(52, 67, 111, 0.25)" : "2px solid transparent",
                          overflow: "hidden",
                        }}
                      >
                        <Avatar src={row.avatar} sx={{ width: 36, height: 36, bgcolor: "primary.400" }} />
                        <Typography
                          noWrap
                          sx={{ fontSize: 14, fontWeight: 700, color: (t) => t.palette?.primary?.[900] }}
                        >
                          {row.empleado}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      <Typography noWrap sx={{ fontSize: 14, color: (t) => t.palette?.primary?.[900] }}>
                        {row.tipo}
                      </Typography>
                    </TableCell>

                    <TableCell align="center">
                      <Typography noWrap sx={{ fontSize: 14, color: (t) => t.palette?.primary?.[900] }}>
                        {row.prioridad}
                      </Typography>
                    </TableCell>

                    <TableCell align="center">
                      <EstadoPill estadoApi={row?._raw?.estado} label={row.estado} />
                    </TableCell>

                    <TableCell align="center">
                      <Typography noWrap sx={{ fontSize: 14, color: (t) => t.palette?.primary?.[900] }}>
                        {row.fecha}
                      </Typography>
                    </TableCell>

                    <TableCell align="center">
                      <Typography noWrap sx={{ fontSize: 14, color: (t) => t.palette?.primary?.[900] }}>
                        {row.sucursal}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}

              {rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4, opacity: 0.7 }}>
                    No hay reclamos para mostrar.
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
}
